<div class="my-offer-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>
  <div *ngIf="loggedInUser.role_id === 3; else buyerOrArtist" style="padding: 2%; text-align: justify;">
    {{'artistAccountNotValidatedYet' | translate}}
  </div>
  <ng-template #buyerOrArtist>
    <div *ngIf="isDataReady">
      <table class="account-table" *ngIf="offers.length > 0">
        <tr>
          <th>
            {{'art' | translate}}
          </th>
          <th class="hide-mobile">
            {{'details' | translate}}
          </th>
          <th *ngIf="loggedInUser.role_id === 2">
            {{'offerUser' | translate}}
          </th>
          <th class="hide-mobile">
            {{'offerDate' | translate}}
          </th>
          <th class="small-mobile">
            {{'state' | translate}}
          </th>
        </tr>
        <tr *ngFor="let offer of offers" class="lazy-load hidden" #lazyElement>
          <td>
            <img [src]="backendAddress + offer.art_object.file_path" alt="oferte primite">
          </td>
          <td class="description hide-mobile">
            <p>{{offer.art_object.title}} <br> {{offer.art_object.dimension}}, {{offer.art_object.year}} lei</p>
          </td>
          <td *ngIf="loggedInUser.role_id === 2">
            <button mat-raised-button (click)="seeBuyerDetails(offer)" class="simple-button">{{'details' | translate}}</button>
          </td>
          <td class="hide-mobile">
            {{offer.updated_at}}
          </td>
          <td *ngIf="loggedInUser.role_id === 2" class="small-mobile">
            <mat-form-field class="full-width" [ngClass]="'state-' + offer.status">
              <mat-select [(value)]="offer.status" (selectionChange)="changeOfferState(offer, $event)">
                <mat-option [value]="state.id"  *ngFor="let state of states" [value]="state.id">{{state.name | translate}}</mat-option>
              </mat-select>
            </mat-form-field>

          </td>
          <td *ngIf="loggedInUser.role_id == 1 && offer.status === 1" class="pending-td small-mobile">
           <div class="flex">
             <mat-icon>alarm</mat-icon>{{'statePending' | translate}}
           </div>
          </td>
          <td *ngIf="loggedInUser.role_id == 1 && offer.status === 2" class="approved-td small-mobile">
            <div class="flex">
              <mat-icon>check_circle</mat-icon>{{'stateApproved' | translate}}
            </div>
          </td>
        </tr>
      </table>
      <p *ngIf="offers.length === 0" style="padding: 2%;">{{'noOffers' | translate}}</p>
    </div>
  </ng-template>
</div>
